(() => {
  if (window.customProductDesktopGalleryV1) return;
  window.customProductDesktopGalleryV1 = true;
  const desktop = matchMedia('(min-width: 750px)');
  // Variant refreshes follow the current gallery order; manual gallery navigation stays native.
  customElements.whenDefined('media-gallery').then(() => {
    const proto = customElements.get('media-gallery').prototype;
    if (proto.customFirstPhotoV1) return;
    proto.customFirstPhotoV1 = true;
    const activate = proto.setActiveMedia;
    proto.setActiveMedia = function(mediaId, prepend) {
      if (prepend && this.hasAttribute('data-custom-first-photo-v1')) {
        const first = this.querySelector('[id^="GalleryViewer"] li[data-media-id]');
        if (first) return activate.call(this, first.dataset.mediaId, false);
      }
      return activate.call(this, mediaId, prepend);
    };
  });

  const initialize = () => {
    document.querySelectorAll('[data-custom-desktop-gallery-v1]').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer && !gallery.dataset.customHeartPositionReady) {
        gallery.dataset.customHeartPositionReady = 'true';
        const positionHeart = () => {
          if (!desktop.matches) return;
          const wrapper = gallery.closest('.product__media-wrapper');
          if (wrapper) wrapper.style.setProperty('--custom-gallery-heart-top', `${viewer.getBoundingClientRect().top - wrapper.getBoundingClientRect().top + 12}px`);
        };
        new ResizeObserver(positionHeart).observe(gallery);
        desktop.addEventListener('change', positionHeart);
        positionHeart();
      }
      if (viewer && !viewer.querySelector('.custom-desktop-photo-arrow') && viewer.querySelectorAll('.product__media-item[data-media-id]').length > 1) {
        ['previous', 'next'].forEach((direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'custom-desktop-photo-arrow';
          button.dataset.direction = direction;
          button.setAttribute('aria-label', direction === 'previous' ? 'Previous product photo' : 'Next product photo');
          button.innerHTML = `<svg viewBox="0 0 14 24" fill="none" aria-hidden="true"><path d="${direction === 'previous' ? 'M11 3 2 12l9 9' : 'm3 3 9 9-9 9'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          const chevron = button.querySelector('path');
          const outline = chevron.cloneNode(true);
          outline.setAttribute('stroke', 'white');
          outline.setAttribute('stroke-width', '3.2');
          outline.setAttribute('opacity', '0.9');
          outline.setAttribute('class', 'custom-photo-arrow-white-outline');
          chevron.before(outline);
          button.addEventListener('click', (event) => {
            if (!desktop.matches) return;
            event.preventDefault();
            event.stopPropagation();
            const items = [...viewer.querySelectorAll('.product__media-item[data-media-id]')].filter((item) => !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active'));
            const index = items.findIndex((item) => item.classList.contains('is-active'));
            const target = items[(index + (direction === 'previous' ? -1 : 1) + items.length) % items.length];
            if (target) gallery.setActiveMedia(target.dataset.mediaId, false);
          });
          viewer.append(button);
        });
      }
      const list = gallery.querySelector('.thumbnail-list');
      if (!list || gallery.dataset.customVerticalReady) return;
      gallery.dataset.customVerticalReady = 'true';
      const controls = gallery.querySelectorAll('[id^="GalleryThumbnails"] > .slider-button');
      const update = () => {
        if (!desktop.matches) return;
        const overflow = list.scrollHeight > list.clientHeight + 1;
        gallery.dataset.customThumbnailScroll = String(overflow);
        controls.forEach((button) => { if (overflow && button.disabled) button.disabled = false; });
      };
      const disabledObserver = new MutationObserver(update);
      controls.forEach((button) => disabledObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] }));
      new ResizeObserver(update).observe(list);
      gallery.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        const button = event.target.closest('[id^="GalleryThumbnails"] > .slider-button');
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        list.scrollBy({ top: button.name === 'previous' ? -288 : 288, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, true);
      list.addEventListener('scroll', update, { passive: true });
      update();
      requestAnimationFrame(update);
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; initialize(); });
  }).observe(document.body, { subtree: true, childList: true });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-custom-desktop-gallery-v1] [id^="GalleryThumbnails"] > .slider-button').forEach((button) => {
      if (desktop.matches) button.disabled = false;
      else button.closest('slider-component')?.resetPages?.();
    });
    initialize();
  });
  initialize();
})();
